export const getFileName = (file: string): string => {
  return file.split(".").slice(0, -1).join(".");
};
